/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading, camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { withDynamicImport } from '@thd-nucleus/app-render';
import { Skeleton, SkeletonBlock, SkeletonLine } from '@one-thd/sui-atomic-components';
import { useHydratedProps, withLayout, withLayoutAccordion, mergeProductClientOnlyProduct }
from '@thd-olt-component-react/fusion-utils';

import { SuperSkuMiddleware as SuperSkuMiddleware_MiddlewareSlot
  ,
  RulesMiddleware as RulesMiddleware_MiddlewareSlot
  , withMagicApronTNT } from '@thd-olt-component-middleware/pip';

import { AugmentedReality as AugmentedRealitySSR } from '@thd-olt-component-react/augmented-reality?clientSideRemove';

import { DisclaimerMessage as DisclaimerMessageSSR } from '@thd-olt-component-react/disclaimer-message?clientSideRemove';

import { ConsumerCardMessaging as ConsumerCardMessagingSSR } from '@thd-olt-component-react/consumer-card-messaging?clientSideRemove';

import { GlobalCustomConfigurator as GlobalCustomConfiguratorSSR } from '@thd-olt-component-react/global-custom-configurator?clientSideRemove';

import { AisleBay as AisleBaySSR } from '@thd-olt-component-react/aisle-bay?clientSideRemove';

import { SuperSku as SuperSkuSSR } from '@thd-olt-component-react/super-sku?clientSideRemove';

import { OrderSample as OrderSampleSSR } from '@thd-olt-component-react/order-sample?clientSideRemove';

import { ReturnsMessaging as ReturnsMessagingSSR } from '@thd-olt-component-react/returns-messaging?clientSideRemove';

import { BotPrompt as BotPromptSSR } from '@thd-olt-component-react/magic-apron?clientSideRemove';

import { ProductOverviewAccordionBody as ProductOverviewAccordionBodySSR } from '@thd-olt-component-react/product-overview?clientSideRemove';

import { SpecificationsAccordionBody as SpecificationsAccordionBodySSR } from '@thd-olt-component-react/specifications?clientSideRemove';

import { QuestionsAndAnswersAccordionBody as QuestionsAndAnswersAccordionBodySSR } from '@thd-olt-component-react/questions-and-answers?clientSideRemove';

import { RatingsAndReviewsAccordionBody as RatingsAndReviewsAccordionBodySSR } from '@thd-olt-component-react/ratings-and-reviews?clientSideRemove';

import { ProductOverviewAccordionTitle as ProductOverviewAccordionTitleSlotG7Index0K0Header }
from '@thd-olt-component-react/product-overview';

import { SpecificationsAccordionTitle as SpecificationsAccordionTitleSlotG7Index1K0Header }
from '@thd-olt-component-react/specifications';

import { QuestionsAndAnswersAccordionTitle as QuestionsAndAnswersAccordionTitleSlotG7Index2K0Header }
from '@thd-olt-component-react/questions-and-answers';

import { RatingsAndReviewsAccordionTitle as RatingsAndReviewsAccordionTitleSlotG7Index3K0Header }
from '@thd-olt-component-react/ratings-and-reviews';

const lazySlots = {};
const getPlaceholder = ({ skip }) => {
  if (skip) return null;
  return (
    <Skeleton>
      <SkeletonBlock />
      <SkeletonLine />
    </Skeleton>
  );
};

const SlotF3Placeholder0 = null;

const SlotF3Index0Client = () => {
  return import(
    '@thd-olt-component-react/augmented-reality');
};

export const SlotF3Index0Load = withDynamicImport({
  server: () => {
    return AugmentedRealitySSR;
  },
  client: SlotF3Index0Client,
  placeholder: SlotF3Placeholder0 || getPlaceholder({ skip: true }),
  name: 'AugmentedReality',
});

lazySlots.LazySlotF3 = withLayout(

  [

    SlotF3Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotF3Index0Client,
      placeholder: SlotF3Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotF6Placeholder0 = null;

const SlotF6Index0Client = () => {
  return import(
    '@thd-olt-component-react/disclaimer-message');
};

export const SlotF6Index0Load = withDynamicImport({
  server: () => {
    return DisclaimerMessageSSR;
  },
  client: SlotF6Index0Client,
  placeholder: SlotF6Placeholder0 || getPlaceholder({ skip: true }),
  name: 'DisclaimerMessage',
});

lazySlots.LazySlotF6 = withLayout(

  [

    SlotF6Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotF6Index0Client,
      placeholder: SlotF6Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const PLCCAbovePlaceholder0 = null;

const PLCCAboveIndex0Client = () => {
  return import(
    '@thd-olt-component-react/consumer-card-messaging');
};

export const PLCCAboveIndex0Load = withDynamicImport({
  server: () => {
    return ConsumerCardMessagingSSR;
  },
  client: PLCCAboveIndex0Client,
  placeholder: PLCCAbovePlaceholder0 || getPlaceholder({ skip: true }),
  name: 'ConsumerCardMessaging',
});

lazySlots.LazyPLCCAbove = withLayout(

  [

    PLCCAboveIndex0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: PLCCAboveIndex0Client,
      placeholder: PLCCAbovePlaceholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotF9Placeholder0 = null;

const SlotF9Index0Client = () => {
  return import(
    '@thd-olt-component-react/global-custom-configurator');
};

export const SlotF9Index0Load = withDynamicImport({
  server: () => {
    return GlobalCustomConfiguratorSSR;
  },
  client: SlotF9Index0Client,
  placeholder: SlotF9Placeholder0 || getPlaceholder({ skip: true }),
  name: 'GlobalCustomConfigurator',
});

lazySlots.LazySlotF9 = withLayout(

  [

    SlotF9Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotF9Index0Client,
      placeholder: SlotF9Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotF11Placeholder0 = null;

const SlotF11Index0Client = () => {
  return import(
    '@thd-olt-component-react/aisle-bay');
};

export const SlotF11Index0Load = withDynamicImport({
  server: () => {
    return AisleBaySSR;
  },
  client: SlotF11Index0Client,
  placeholder: SlotF11Placeholder0 || getPlaceholder({ skip: true }),
  name: 'AisleBay',
});

lazySlots.LazySlotF11 = withLayout(

  [

    SlotF11Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotF11Index0Client,
      placeholder: SlotF11Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotF12Placeholder0 = null;

const SlotF12Index0Client = () => {
  return import(
    '@thd-olt-component-react/super-sku');
};

export const SlotF12Index0Load = withDynamicImport({
  server: () => {
    return SuperSkuSSR;
  },
  client: SlotF12Index0Client,
  placeholder: SlotF12Placeholder0 || getPlaceholder({ skip: true }),
  name: 'SuperSku',
});

let SuperSkuMiddleware_MiddlewareSlot_SlotF12 = SuperSkuMiddleware_MiddlewareSlot;

lazySlots.LazySlotF12 = withLayout(

  [

    SlotF12Index0Load,

  ],

  SuperSkuMiddleware_MiddlewareSlot_SlotF12
  ,

  [

    {
      waitForComponent: SlotF12Index0Client,
      placeholder: SlotF12Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotF14Placeholder0 = null;

const SlotF14Index0Client = () => {
  return import(
    '@thd-olt-component-react/order-sample');
};

export const SlotF14Index0Load = withDynamicImport({
  server: () => {
    return OrderSampleSSR;
  },
  client: SlotF14Index0Client,
  placeholder: SlotF14Placeholder0 || getPlaceholder({ skip: true }),
  name: 'OrderSample',
});

lazySlots.LazySlotF14 = withLayout(

  [

    SlotF14Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotF14Index0Client,
      placeholder: SlotF14Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotF16Placeholder0 = null;

const SlotF16Index0Client = () => {
  return import(
    '@thd-olt-component-react/returns-messaging');
};

export const SlotF16Index0Load = withDynamicImport({
  server: () => {
    return ReturnsMessagingSSR;
  },
  client: SlotF16Index0Client,
  placeholder: SlotF16Placeholder0 || getPlaceholder({ skip: true }),
  name: 'ReturnsMessaging',
});

lazySlots.LazySlotF16 = withLayout(

  [

    SlotF16Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotF16Index0Client,
      placeholder: SlotF16Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotG6Placeholder0 = null;

const SlotG6Index0Client = () => {
  return import(
    '@thd-olt-component-react/magic-apron');
};

export const SlotG6Index0Load = withDynamicImport({
  server: () => {
    return BotPromptSSR;
  },
  client: SlotG6Index0Client,
  placeholder: SlotG6Placeholder0 || getPlaceholder({ skip: true }),
  name: 'BotPrompt',
});

let RulesMiddleware_MiddlewareSlot_SlotG6 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_SlotG6 = withMagicApronTNT(RulesMiddleware_MiddlewareSlot_SlotG6, { render: { name: 'fs-prop:magic-apron-qa-bot-render-placement', value: 'above-accordion' } });

lazySlots.LazySlotG6 = withLayout(

  [

    SlotG6Index0Load,

  ],

  RulesMiddleware_MiddlewareSlot_SlotG6
  ,

  [

    {
      waitForComponent: SlotG6Index0Client,
      placeholder: SlotG6Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotG7Placeholder0K0 = null;

const SlotG7Index0ClientK0 = () => {
  return import(
    '@thd-olt-component-react/product-overview');
};

export const SlotG7Index0LoadK0 = withDynamicImport({
  server: () => {
    return ProductOverviewAccordionBodySSR;
  },
  client: SlotG7Index0ClientK0,
  placeholder: SlotG7Placeholder0K0 || getPlaceholder({ skip: true }),
  name: 'ProductOverviewAccordionBody',
});

lazySlots.LazySlotG7KBody1 = withLayout(
  SlotG7Index0LoadK0,

  null
  ,
  {
    waitForComponent: SlotG7Index0ClientK0,
    placeholder: SlotG7Placeholder0K0 || getPlaceholder({ skip: true })
  }
);

const SlotG7Placeholder1K0 = null;

const SlotG7Index1ClientK0 = () => {
  return import(
    '@thd-olt-component-react/specifications');
};

export const SlotG7Index1LoadK0 = withDynamicImport({
  server: () => {
    return SpecificationsAccordionBodySSR;
  },
  client: SlotG7Index1ClientK0,
  placeholder: SlotG7Placeholder1K0 || getPlaceholder({ skip: true }),
  name: 'SpecificationsAccordionBody',
});

lazySlots.LazySlotG7KBody2 = withLayout(
  SlotG7Index1LoadK0,

  null
  ,
  {
    waitForComponent: SlotG7Index1ClientK0,
    placeholder: SlotG7Placeholder1K0 || getPlaceholder({ skip: true })
  }
);

const SlotG7Placeholder2K0 = null;

const SlotG7Index2ClientK0 = () => {
  return import(
    '@thd-olt-component-react/questions-and-answers');
};

export const SlotG7Index2LoadK0 = withDynamicImport({
  server: () => {
    return QuestionsAndAnswersAccordionBodySSR;
  },
  client: SlotG7Index2ClientK0,
  placeholder: SlotG7Placeholder2K0 || getPlaceholder({ skip: true }),
  name: 'QuestionsAndAnswersAccordionBody',
});

lazySlots.LazySlotG7KBody3 = withLayout(
  SlotG7Index2LoadK0,

  null
  ,
  {
    waitForComponent: SlotG7Index2ClientK0,
    placeholder: SlotG7Placeholder2K0 || getPlaceholder({ skip: true })
  }
);

const SlotG7Placeholder3K0 = null;

const SlotG7Index3ClientK0 = () => {
  return import(
    '@thd-olt-component-react/ratings-and-reviews');
};

export const SlotG7Index3LoadK0 = withDynamicImport({
  server: () => {
    return RatingsAndReviewsAccordionBodySSR;
  },
  client: SlotG7Index3ClientK0,
  placeholder: SlotG7Placeholder3K0 || getPlaceholder({ skip: true }),
  name: 'RatingsAndReviewsAccordionBody',
});

lazySlots.LazySlotG7KBody4 = withLayout(
  SlotG7Index3LoadK0,

  null
  ,
  {
    waitForComponent: SlotG7Index3ClientK0,
    placeholder: SlotG7Placeholder3K0 || getPlaceholder({ skip: true })
  }
);

const LazySlotG7Accordion = withLayoutAccordion([
  [

    [

      withLayout(
        ProductOverviewAccordionTitleSlotG7Index0K0Header,

      ),

    ],

    [

      withLayout(
        SpecificationsAccordionTitleSlotG7Index1K0Header,

      ),

    ],

    [

      withLayout(
        QuestionsAndAnswersAccordionTitleSlotG7Index2K0Header,

      ),

    ],

    [

      withLayout(
        RatingsAndReviewsAccordionTitleSlotG7Index3K0Header,

      ),

    ],

  ],
  [

    [

      lazySlots.LazySlotG7KBody1,

    ],

    [

      lazySlots.LazySlotG7KBody2,

    ],

    [

      lazySlots.LazySlotG7KBody3,

    ],

    [

      lazySlots.LazySlotG7KBody4,

    ],

  ]
],

null
);

const SlotG8Placeholder0 = null;

const SlotG8Index0Client = () => {
  return import(
    '@thd-olt-component-react/magic-apron');
};

export const SlotG8Index0Load = withDynamicImport({
  server: () => {
    return BotPromptSSR;
  },
  client: SlotG8Index0Client,
  placeholder: SlotG8Placeholder0 || getPlaceholder({ skip: true }),
  name: 'BotPrompt',
});

let RulesMiddleware_MiddlewareSlot_SlotG8 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_SlotG8 = withMagicApronTNT(RulesMiddleware_MiddlewareSlot_SlotG8, { render: { name: 'fs-prop:magic-apron-qa-bot-render-placement', value: 'default', default: true } });

lazySlots.LazySlotG8 = withLayout(

  [

    SlotG8Index0Load,

  ],

  RulesMiddleware_MiddlewareSlot_SlotG8
  ,

  [

    {
      waitForComponent: SlotG8Index0Client,
      placeholder: SlotG8Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

// to be generated by ejs based on config
export const DynamicImporter = (props) => {
  const { storeId, storeZip } = useStore();
  const slot = props.config.slots[props.slot];
  const components = slot.isAccordion
    ? slot.components.flat().map((sc) => sc.components).flat()
    : slot.components.flat();

  // todo use merge option?
  const hydratedProps = useHydratedProps(components, { itemId: props.itemId });
  components.forEach((com, index) => {
    // eslint-disable-next-line no-param-reassign
    com.props = hydratedProps[index];
  });

  const merge = mergeProductClientOnlyProduct;

  // use this for debugging, attache to queryProvider prop

  // const queryOptions = ({ options, queryName }) => {
  //   return {
  //     ...options,
  //     fetchPolicy: 'cache-only'
  //   };
  // };

  const ssr = typeof window === 'undefined';
  const decisionIndex = ssr
    ? 0
    : Number(
      (window.__SLOT_DECISIONS__ && window.__SLOT_DECISIONS__[props.slot]) ?? '0'
    );

  if (props.slot === 'SlotF3') {

    return (
      <lazySlots.LazySlotF3
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="SlotF3"
        fusionComponentName="@thd-olt-component-react/augmented-reality"
        version="7.5.5"
      />
    );

  }

  if (props.slot === 'SlotF6') {

    return (
      <lazySlots.LazySlotF6
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="SlotF6"
        fusionComponentName="@thd-olt-component-react/disclaimer-message"
        version="6.2.0"
      />
    );

  }

  if (props.slot === 'PLCCAbove') {

    return (
      <lazySlots.LazyPLCCAbove
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="PLCCAbove"
        fusionComponentName="@thd-olt-component-react/consumer-card-messaging"
        version="9.10.2"
      />
    );

  }

  if (props.slot === 'SlotF9') {

    return (
      <lazySlots.LazySlotF9
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="SlotF9"
        fusionComponentName="@thd-olt-component-react/global-custom-configurator"
        version="2.6.0"
      />
    );

  }

  if (props.slot === 'SlotF11') {

    return (
      <lazySlots.LazySlotF11
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="SlotF11"
        fusionComponentName="@thd-olt-component-react/aisle-bay"
        version="7.14.1"
      />
    );

  }

  if (props.slot === 'SlotF12') {

    return (
      <lazySlots.LazySlotF12
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="SlotF12"
        fusionComponentName="@thd-olt-component-react/super-sku"
        version="13.35.0"
      />
    );

  }

  if (props.slot === 'SlotF14') {

    return (
      <lazySlots.LazySlotF14
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="SlotF14"
        fusionComponentName="@thd-olt-component-react/order-sample"
        version="5.15.4"
      />
    );

  }

  if (props.slot === 'SlotF16') {

    return (
      <lazySlots.LazySlotF16
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="SlotF16"
        fusionComponentName="@thd-olt-component-react/returns-messaging"
        version="1.16.0"
      />
    );

  }

  if (props.slot === 'SlotG6') {

    return (
      <lazySlots.LazySlotG6
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="SlotG6"
        fusionComponentName="@thd-olt-component-react/magic-apron"
        version="8.8.0"
      />
    );

  }

  if (props.slot === 'SlotG7') {

    return (
      <LazySlotG7Accordion
        {...props}
        config={props.config}
        fusionSlotName="SlotG7"
        fusionComponentName="accordion"
        fusionClassName={slot.fusionClassName}
        isDynamic
        // commenting inner query provider since withDynamicImport already wraps AccordionBody with inner query provider
        // queryProvider={{
        //   inherit: 'page',
        //   merge,
        //   queryOptions,
        //   cache key for all accordions must be the same
        //   otherwise a race condition will occur generating duplicate requests
        //   cacheKey: 'page',
        //   defaultVariables: props?.qctx?.defaultVariables?.current || { storeId, zipCode: storeZip }
        // }}
      />
    );

  }

  if (props.slot === 'SlotG8') {

    return (
      <lazySlots.LazySlotG8
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="SlotG8"
        fusionComponentName="@thd-olt-component-react/magic-apron"
        version="8.8.0"
      />
    );

  }

  return null;
};

DynamicImporter.propTypes = {
  config: PropTypes.shape({
    slots: PropTypes.shape({})
  }).isRequired,
  slot: PropTypes.string.isRequired,
};